import type { MaybeRefOrGetter } from 'vue';
import type { GlobalCollectionId } from '#layers/data-model/types/schema/ids';
import { computed, toValue } from 'vue';
import { useWorkspaceSchemaStore } from '#layers/workspace/public';

export function useCollection(collectionId: MaybeRefOrGetter<GlobalCollectionId | null | undefined>) {
	const { findCollectionById } = useWorkspaceSchemaStore();

	return {
		collection: computed(() => {
			const id = toValue(collectionId);
			return id ? findCollectionById(id) : undefined;
		}),
	};
}

export function useCollectionByName(collectionName: MaybeRefOrGetter<string | null | undefined>) {
	const { findCollectionByName } = useWorkspaceSchemaStore();

	return {
		collection: computed(() => {
			const name = toValue(collectionName);
			return name ? findCollectionByName(name) : undefined;
		}),
	};
}
